import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CapabilityCardComponent } from './capability-card.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { IconsModule } from 'src/app/icons/icons.module';
import { CapabilityDetailsModule } from 'src/app/components/capability-details/capability-details.module';


@NgModule({
  declarations: [
    CapabilityCardComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    IconsModule,
    CapabilityDetailsModule
  ],
  exports: [
    CapabilityCardComponent
  ],
})
export class CapabilityCardModule { }
